import { useEffect, useState } from "react";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { capitalize } from "../../../../utils/strings/capitalize";

interface InfoFenceProps {
  task: ITaskFence | undefined;
}

export default function InfoFence(task: InfoFenceProps) {
  const [taskFence, setTaskFence] = useState<ITaskFence>();
  const hasSkipReason = taskFence?.skip_reason != null;

  useEffect(() => {
    setTaskFence(task.task)
  }, []);


  return (
    <>
      <div >
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskFence?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi concluída?`} pointed />
        <ButtonYesOrNo onlyResult optionSelected={hasSkipReason ? "no" : "yes"} />
      </div>

      {hasSkipReason ? (
        <MessageBalloon text={`${taskFence?.skip_reason}`} answer />
      ) : (
        <MessageBalloon text={`${capitalize(taskFence?.activity?.toLowerCase() || "")} cerca ${taskFence?.material ? `${taskFence?.material?.toLocaleLowerCase()} de ${taskFence?.structure?.toLocaleLowerCase()} - ${taskFence?.wire_quantity} fios` : ""}`} pointed />
      )}
    </>
  )
}
